import type { RuleGroupType, RuleType } from 'react-querybuilder';

// RQB stamps a fresh `id` on the root and on every rule the moment it mounts, so a plain
// deep-compare against the stored tree always reports a change. Only group/rule nodes are
// stripped — a leaf's own `value` is left alone, since its shape is the field type's, not
// RQB's.
export const withoutRqbIds = (node: RuleGroupType | RuleType): unknown => {
  const { id: _id, ...rest } = node as unknown as Record<string, unknown> & { id?: string };
  return Array.isArray(rest.rules)
    ? { ...rest, rules: (rest.rules as (RuleGroupType | RuleType)[]).map(withoutRqbIds) }
    : rest;
};
